import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Department } from 'src/app/models/department.model';
import { DepartmentService } from 'src/app/services/department.service';

@Component({
    selector: 'app-department',
    templateUrl: './department.component.html',
    styleUrls: ['./department.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DepartmentComponent {

  department: Department;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DepartmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    protected departments: DepartmentService
  ) {
    this.department = data.department;
  }

  async save() {
    let result = { ...this.department };

    try {
      await this.departments.save(result);
      this.dialogRef.close(result);
    } catch (error) {
      console.error(error);
    }
  }
}
